// src/web/routes/_authenticated/collections/index.tsx
import { createFileRoute } from '@tanstack/react-router'
import { CollectionsList } from '@/components/features/CollectionsList'

export const Route = createFileRoute('/_authenticated/collections/')({
	component: CollectionsPage,
})

function CollectionsPage() {
	return (
		<div className="min-h-full pt-20">
			<CollectionsList />
		</div>
	)
}
